import React, { useState } from 'react';
import { Card, SectionTitle, Row, Btn, Avatar, Chip, Badge, StatBox, ProgressBar, EmptyState, PageHeader } from '../components/UI';

// ── ADMIN DASHBOARD ──────────────────────────────────────────────
export function AdminDashboard({ t, pending, members, onNav }) {
  const paid = members.filter(m => m.paid).length;
  const unpaid = members.filter(m => !m.paid).length;
  return (
    <div style={{ padding: '0 0 24px' }}>
      <div style={{ background: t.isDark ? '#040f08' : '#1B5E20', padding: '20px 20px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ color: t.isDark ? '#81C784' : '#A5D6A7', fontSize: 12, fontWeight: 600 }}>Admin Panel</div>
            <div style={{ color: '#fff', fontSize: 22, fontWeight: 900, marginTop: 2 }}>Md. Sumon Sarker</div>
            <div style={{ marginTop: 6 }}><div style={{ background: '#C8A400', borderRadius: 7, padding: '3px 9px', fontSize: 11, color: '#1B5E20', fontWeight: 800, display: 'inline-block' }}>Super Admin</div></div>
          </div>
        </div>
      </div>
      <div style={{ padding: '16px 16px 0' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
          <StatBox t={t} value={members.length} label="Total members" />
          <StatBox t={t} value={pending.length} label="Pending" color="#F57C00" bg="#FFF8E1" border="#FFE082" />
          <StatBox t={t} value="৳58.8L" label="Collected" />
          <StatBox t={t} value={unpaid} label="Unpaid ⚠" color="#C62828" bg="#FFEBEE" border="#EF9A9A" />
        </div>
        <Card t={t} style={{ marginBottom: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, fontWeight: 700, marginBottom: 6 }}><span style={{ color: t.primary }}>June compliance</span><span style={{ color: t.primary }}>86%</span></div>
          <ProgressBar t={t} value={86} max={100} />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: t.textSec, marginTop: 6, fontWeight: 600 }}><span style={{ color: t.primary }}>36 paid</span><span style={{ color: '#F57C00' }}>4 pending</span><span style={{ color: '#C62828' }}>2 unpaid</span></div>
        </Card>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 14 }}>
          {[['✅ Approve', '#2E7D32', '#E8F5E9', '#A5D6A7', 'approvals', pending.length], ['👥 Members', '#BF360C', '#FFEBEE', '#EF9A9A', 'members', null], ['📊 Compliance', '#1565C0', '#E3F2FD', '#90CAF9', 'compliance', null], ['📢 Announce', '#6A1B9A', '#F3E5F5', '#CE93D8', 'announce', null]].map(([l, c, bg, br, key, badge]) => (
            <div key={key} onClick={() => onNav(key)} style={{ background: t.isDark ? t.surface : bg, border: `0.5px solid ${t.isDark ? t.border : br}`, borderRadius: 12, padding: '14px 12px', cursor: 'pointer', position: 'relative' }}>
              {badge > 0 && <div style={{ position: 'absolute', top: 8, right: 8, background: '#C62828', color: '#fff', borderRadius: 10, width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900 }}>{badge}</div>}
              <div style={{ fontSize: 14, fontWeight: 800, color: t.isDark ? t.primary : c }}>{l}</div>
            </div>
          ))}
        </div>
        <Card t={t}>
          <SectionTitle t={t} label={`Pending approvals (${pending.length})`} />
          {pending.length === 0 && <div style={{ textAlign: 'center', padding: '16px 0', fontSize: 13, color: t.textHint, fontWeight: 600 }}>✅ All payments reviewed!</div>}
          {pending.map(p => (
            <div key={p.id} onClick={() => onNav('approvals')} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: `0.5px solid ${t.border}`, cursor: 'pointer' }}>
              <Avatar initials={p.initials} gradient={p.gradient} size={36} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 800, color: t.text }}>{p.name}</div>
                <div style={{ fontSize: 11, color: t.textSec, fontWeight: 600 }}>{p.amount.toLocaleString()} BDT · {p.method}</div>
              </div>
              {p.rejections > 0 && <Chip label={`⚠ ${p.rejections}`} color="#F57C00" bg="#FFF8E1" border="#FFE082" />}
              <div style={{ background: t.primaryLight, borderRadius: 8, padding: '5px 12px', fontSize: 12, fontWeight: 800, color: t.primary }}>Review</div>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}

// ── ADMIN APPROVALS with auto-email receipt flow ──────────────────
export function AdminApprovals({ t, pending, onApprove, onReject, onBack }) {
  const [successPay, setSuccessPay] = useState(null);
  const [rejectPay, setRejectPay] = useState(null);
  const [rejectNote, setRejectNote] = useState('');

  const handleApprove = (p) => {
    setSuccessPay(p);
    setTimeout(() => { setSuccessPay(null); onApprove(p.id); }, 3000);
  };

  if (successPay) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 400, padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 64, marginBottom: 14 }}>✅</div>
      <div style={{ fontSize: 22, fontWeight: 900, color: t.primary }}>Payment Approved!</div>
      <div style={{ fontSize: 13, color: t.textSec, fontWeight: 600, marginTop: 6 }}>Auto-processing...</div>
      <Card t={t} style={{ marginTop: 20, width: '100%', maxWidth: 400 }}>
        <SectionTitle t={t} label="Automated actions completed" />
        {['📄 Receipt PDF generated (SBG-2025-P02-0042)', `📧 Email sent to ${successPay.name.split(' ')[0].toLowerCase()}@gmail.com`, '📋 Payment record updated', '🔔 Member notified via push'].map((a, i) => (
          <div key={i} style={{ fontSize: 13, color: t.text, fontWeight: 600, padding: '6px 0', borderBottom: i < 3 ? `0.5px solid ${t.border}` : 'none', lineHeight: 1.5 }}>{a}</div>
        ))}
      </Card>
      <div style={{ fontSize: 12, color: t.textHint, marginTop: 14, fontWeight: 500 }}>Zero extra steps — fully automatic.</div>
    </div>
  );

  return (
    <div style={{ padding: '16px 16px 32px' }}>
      {pending.length === 0 && <EmptyState t={t} icon="✅" title="All caught up!" subtitle="No payments pending review right now." />}
      {pending.map(p => (
        <Card t={t} key={p.id} style={{ marginBottom: 16, borderColor: p.rejections > 0 ? '#FFE082' : t.border }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <Avatar initials={p.initials} gradient={p.gradient} size={44} />
              <div>
                <div style={{ fontSize: 16, fontWeight: 900, color: t.text }}>{p.name}</div>
                <div style={{ fontSize: 12, color: t.textSec, fontWeight: 600, marginTop: 1 }}>{p.id}</div>
              </div>
            </div>
            {p.rejections > 0 ? (
              <div style={{ background: '#FFF8E1', border: '0.5px solid #FFE082', borderRadius: 9, padding: '5px 10px', textAlign: 'center' }}>
                <div style={{ fontSize: 11, fontWeight: 800, color: '#F57C00' }}>⚠ {p.rejections} prior</div>
                <div style={{ fontSize: 10, color: t.textHint, fontWeight: 600 }}>rejections</div>
              </div>
            ) : <Chip label="✓ Clean record" color="#2E7D32" bg="#E8F5E9" border="#A5D6A7" />}
          </div>
          <Row t={t} label="Amount" value={`${p.amount.toLocaleString()} BDT`} valueColor={t.primary} />
          <Row t={t} label="Months covered" value={p.months} />
          <Row t={t} label="Method" value={p.method} />
          <Row t={t} label="Transaction ID" value={p.txId} />
          <Row t={t} label="Screenshot" value="✓ Uploaded" valueColor={t.primary} />
          {p.rejections > 0 && (
            <div style={{ background: '#FFF8E1', borderRadius: 10, padding: '10px 12px', marginTop: 10, border: '0.5px solid #FFE082' }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#F57C00', marginBottom: 5 }}>⚠ Rejection history</div>
              <div style={{ fontSize: 12, color: t.textSec, lineHeight: 1.6, fontWeight: 500 }}>10 May: "Transaction ID could not be verified"<br />03 Apr: "Screenshot was unreadable"</div>
            </div>
          )}
          <div style={{ background: t.primaryLight, borderRadius: 10, padding: '10px 12px', marginTop: 10, border: `0.5px solid ${t.borderLight}` }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: t.primary, marginBottom: 4 }}>On approval — automatic actions:</div>
            <div style={{ fontSize: 11, color: t.textSec, lineHeight: 1.7, fontWeight: 500 }}>📄 Receipt PDF generated → 📧 Email sent to member → 🔔 Push notification → 📋 Record updated</div>
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
            <Btn t={t} label="✓ Approve" onClick={() => handleApprove(p)} bg="#2E7D32" style={{ flex: 1 }} />
            <Btn t={t} label="✗ Reject" onClick={() => { setRejectPay(p); setRejectNote(''); }} bg="#C62828" style={{ flex: 1 }} />
          </div>
        </Card>
      ))}

      {/* Reject modal */}
      {rejectPay && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: t.surface, borderRadius: '20px 20px 0 0', padding: '20px 20px 32px', width: '100%', maxHeight: '60vh' }}>
            <div style={{ fontSize: 16, fontWeight: 900, color: t.red, marginBottom: 12 }}>Reject — {rejectPay.name}</div>
            <div style={{ fontSize: 13, color: t.text, fontWeight: 700, marginBottom: 8 }}>Reason (required — member will see this):</div>
            <textarea value={rejectNote} onChange={e => setRejectNote(e.target.value)} placeholder="e.g. Transaction ID could not be verified on bKash..." style={{ width: '100%', background: t.surface2, border: `0.5px solid ${t.border}`, borderRadius: 10, padding: '12px 14px', fontSize: 13, color: t.text, fontFamily: 'Nunito, sans-serif', resize: 'none', height: 80, outline: 'none' }} />
            <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
              <Btn t={t} label="Cancel" onClick={() => setRejectPay(null)} bg={t.isDark ? '#333' : '#e0e0e0'} color={t.text} style={{ flex: 1 }} />
              <Btn t={t} label="Confirm reject" onClick={() => { onReject(rejectPay.id, rejectNote); setRejectPay(null); }} bg="#C62828" disabled={!rejectNote.trim()} style={{ flex: 1 }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── ADMIN MEMBERS with notes ──────────────────────────────────────
export function AdminMembers({ t, members, onUpdateNotes }) {
  const [selected, setSelected] = useState(null);
  const [newNote, setNewNote] = useState('');
  const [search, setSearch] = useState('');

  const filtered = members.filter(m => m.name.toLowerCase().includes(search.toLowerCase()) || m.id.toLowerCase().includes(search.toLowerCase()));

  const saveNote = () => {
    if (!newNote.trim()) return;
    const note = { author: 'Md. Sumon Sarker', date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }), text: newNote.trim() };
    const updated = [...(selected.notes || []), note];
    onUpdateNotes(selected.id, updated);
    setSelected(prev => ({ ...prev, notes: updated }));
    setNewNote('');
  };

  if (selected) return (
    <div>
      <div style={{ background: 'linear-gradient(135deg,#BF360C,#E64A19)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => setSelected(null)} style={{ background: 'rgba(255,255,255,.15)', border: 'none', borderRadius: 8, width: 36, height: 36, cursor: 'pointer', fontSize: 18, color: '#fff' }}>←</button>
        <Avatar initials={selected.initials} gradient="rgba(255,255,255,.2)" size={46} />
        <div>
          <div style={{ color: '#fff', fontSize: 17, fontWeight: 900 }}>{selected.name}</div>
          <div style={{ color: '#FFCCBC', fontSize: 12, fontWeight: 600 }}>{selected.id} · P02 · {selected.shares} share{selected.shares > 1 ? 's' : ''}</div>
        </div>
      </div>
      <div style={{ padding: '16px 16px 32px' }}>
        <Card t={t} style={{ marginBottom: 14 }}>
          <SectionTitle t={t} label="Member info" />
          <Row t={t} label="Email" value={selected.email} />
          <Row t={t} label="Phone" value={selected.phone} />
          <Row t={t} label="Shares" value={`${selected.shares} share${selected.shares > 1 ? 's' : ''}`} />
          <Row t={t} label="June payment" value={selected.paid ? 'Paid ✓' : 'Unpaid'} valueColor={selected.paid ? t.primary : '#C62828'} />
          <Row t={t} last label="Rejections" value={selected.rejections === 0 ? 'None ✓' : `${selected.rejections} rejections`} valueColor={selected.rejections > 0 ? '#F57C00' : t.primary} />
        </Card>

        {/* Admin notes */}
        <Card t={t} style={{ borderColor: '#FFE082' }}>
          <SectionTitle t={t} label="Admin notes" right={<div style={{ background: '#FFF8E1', border: '0.5px solid #FFE082', borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 700, color: '#E65100' }}>🔒 Private — not visible to member</div>} />
          {(selected.notes || []).length === 0 && <div style={{ textAlign: 'center', padding: '14px 0', fontSize: 13, color: t.textHint, fontWeight: 600 }}>No notes yet. Add one below.</div>}
          {(selected.notes || []).map((note, i) => (
            <div key={i} style={{ background: t.isDark ? '#1e1200' : '#FFF8E1', borderRadius: 10, padding: '10px 12px', marginBottom: 10, border: `0.5px solid ${t.isDark ? '#4a3000' : '#FFE082'}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                <div style={{ fontSize: 12, fontWeight: 800, color: t.isDark ? '#FFB74D' : '#E65100' }}>{note.author}</div>
                <div style={{ fontSize: 11, color: t.textHint, fontWeight: 600 }}>{note.date}</div>
              </div>
              <div style={{ fontSize: 13, color: t.text, lineHeight: 1.6, fontWeight: 500 }}>{note.text}</div>
            </div>
          ))}
          {/* Add note */}
          <div style={{ background: t.isDark ? '#1e1200' : '#FFF8E1', borderRadius: 10, padding: '12px 14px', border: `0.5px solid ${t.isDark ? '#4a3000' : '#FFE082'}`, marginTop: 4 }}>
            <div style={{ fontSize: 12, color: t.isDark ? '#FFB74D' : '#E65100', fontWeight: 700, marginBottom: 8 }}>Add private note</div>
            <textarea value={newNote} onChange={e => setNewNote(e.target.value)} placeholder={`Note about ${selected.name} — visible to admins only...`} style={{ width: '100%', background: t.surface, border: `0.5px solid ${t.border}`, borderRadius: 8, padding: '10px 12px', fontSize: 13, color: t.text, fontFamily: 'Nunito, sans-serif', resize: 'none', height: 70, outline: 'none' }} />
            <Btn t={t} label="Save note" onClick={saveNote} disabled={!newNote.trim()} bg="#E65100" style={{ marginTop: 8 }} />
          </div>
        </Card>
      </div>
    </div>
  );

  return (
    <div style={{ padding: '16px 16px 32px' }}>
      <div style={{ background: t.surface2, borderRadius: 12, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8, border: `0.5px solid ${t.border}`, marginBottom: 14 }}>
        <span style={{ fontSize: 16 }}>🔍</span>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search members..." style={{ background: 'transparent', border: 'none', outline: 'none', fontSize: 14, color: t.text, flex: 1, fontFamily: 'Nunito, sans-serif', fontWeight: 600 }} />
      </div>
      <Card t={t}>
        <SectionTitle t={t} label={`All members (${filtered.length})`} />
        {filtered.map(m => (
          <div key={m.id} onClick={() => setSelected(m)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: `0.5px solid ${t.border}`, cursor: 'pointer' }}>
            <Avatar initials={m.initials} gradient={m.gradient} size={40} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 800, color: t.text }}>{m.name}</div>
              <div style={{ fontSize: 11, color: t.textSec, fontWeight: 600, marginTop: 1 }}>{m.id} · P02 · {m.paid ? 'Paid ✓' : 'Unpaid'}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-end' }}>
              {m.paid ? <Chip label="✓ Paid" color="#2E7D32" bg="#E8F5E9" border="#A5D6A7" /> : <Chip label="Unpaid" color="#C62828" bg="#FFEBEE" border="#EF9A9A" />}
              {m.rejections > 0 && <Chip label={`⚠ ${m.rejections} rej.`} color="#F57C00" bg="#FFF8E1" border="#FFE082" />}
              {(m.notes || []).length > 0 && <div style={{ background: '#FFF8E1', border: '0.5px solid #FFE082', borderRadius: 6, padding: '2px 7px', fontSize: 11, fontWeight: 700, color: '#E65100' }}>📝 {m.notes.length}</div>}
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}

// ── COMPLIANCE SCREEN ─────────────────────────────────────────────
export function AdminCompliance({ t }) {
  return (
    <div style={{ padding: '16px 16px 32px' }}>
      <Card t={t} style={{ marginBottom: 14 }}>
        <SectionTitle t={t} label="June 2025 compliance" />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, fontWeight: 700, marginBottom: 8 }}><span style={{ color: t.primary }}>86% compliance</span><span style={{ color: t.primary }}>36 / 42</span></div>
        <ProgressBar t={t} value={86} max={100} height={10} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginTop: 12 }}>
          {[['36', 'Paid', '#2E7D32', '#E8F5E9', '#A5D6A7'], ['4', 'Pending', '#F57C00', '#FFF8E1', '#FFE082'], ['2', 'Unpaid', '#C62828', '#FFEBEE', '#EF9A9A']].map(([v, l, c, bg, br]) => (
            <div key={l} style={{ background: t.isDark ? t.surface2 : bg, border: `0.5px solid ${t.isDark ? t.border : br}`, borderRadius: 10, padding: 10, textAlign: 'center' }}>
              <div style={{ fontSize: 20, fontWeight: 900, color: t.isDark ? c : c }}>{v}</div>
              <div style={{ fontSize: 11, color: t.textSec, fontWeight: 600, marginTop: 2 }}>{l}</div>
            </div>
          ))}
        </div>
      </Card>
      <Card t={t} style={{ marginBottom: 14 }}>
        <SectionTitle t={t} label="Export reports" />
        {[['📊 Excel (.xlsx)', '4 sheets · chart · formulas', '#1B5E20'], ['📄 CSV', 'Plain — opens in any spreadsheet', '#1565C0'], ['📋 PDF Report', 'Printable with logo', '#6A1B9A']].map(([title, sub, c]) => (
          <div key={title} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0', borderBottom: `0.5px solid ${t.border}` }}>
            <div><div style={{ fontSize: 14, fontWeight: 800, color: t.isDark ? t.primary : c }}>{title}</div><div style={{ fontSize: 11, color: t.textSec, fontWeight: 500, marginTop: 2 }}>{sub}</div></div>
            <div style={{ background: t.isDark ? t.primaryLight : '#E8F5E9', border: `0.5px solid ${t.borderLight}`, borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 800, color: t.isDark ? t.primary : c, cursor: 'pointer' }}>Export</div>
          </div>
        ))}
      </Card>
    </div>
  );
}
